import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

interface LegacyComposeRedirectProps {
  /**
   * Builds the `/studio*` destination path from the route params matched on the legacy
   * `/compose*` pattern. Query string is appended by this component, not the builder — see
   * `location.search` below. A bare `<Navigate to="...">` here would silently drop
   * `?scope=approach:<systemName>` / `?agent=1` / `?openEntry=<systemName>` and break
   * approach-scoped composing without any visible error (SC3).
   */
  toPathFromParams: (params: Readonly<Record<string, string | undefined>>) => string;
}

/** `/compose*` → `/studio*`, preserving `location.search` (EAINT-858). */
const LegacyComposeRedirect: React.FC<LegacyComposeRedirectProps> = ({ toPathFromParams }) => {
  const params = useParams();
  const location = useLocation();
  const to = `${toPathFromParams(params)}${location.search}`;
  // entry: 'redirect' tells StudioShell's studio_opened event this landing came from a legacy
  // /compose* URL, not a nav click or a typed/bookmarked address.
  return <Navigate to={to} replace state={{ entry: 'redirect' }} />;
};

export default LegacyComposeRedirect;
